import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api/api";
import { ENDPOINTS } from "../api/endpoints";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userName, setUserName] = useState("");
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    if (!userId) return;

    //  SINGLE SOURCE: GetUserName endpoint
    api
      .get(ENDPOINTS.getUserName({ userId }))
      .then((res) => {
        const name = res?.data?.userName || "";
        setUserName(name);
      })
      .catch((err) =>
        console.error("Failed to fetch username", err)
      );
  }, [userId]);

  return (
    <UserContext.Provider value={{ userName }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
